import { observable } from 'mobx';
import { action } from 'mobx'
// import mobx from 'mobx'
import _ from 'lodash'
// import cookie from 'react-cookie';
import queryString from 'query-string';
import { urlParam } from '../util/urlParam'
import md5 from 'blueimp-md5';
import swal from 'sweetalert';

let LoginStore = observable(
	{
		id: '',
		veridation_code: '',
		input_veridation_code: '',
		account: '',
		password: '',
		smscode: '',
		open: false,
		SmsView: false,
		dialogText: '',
		revisitNoAccount: 0,
	}
)

function checkStatus(response) {
	if (response.status >= 200 && response.status < 300) {
		return response
	} else {
		var error = new Error(response.statusText)
		error.response = response
		throw error
	}
}

function getCaptcha() {
	LoginStore.input_veridation_code = '';

	var myImage = document.querySelector('img')
	if (myImage !== null) {
		const fetchGetConfig = {
			method: 'GET',
			credentials: 'include'
		}
		var imageUrl = `https://captcha.kfsyscc.org/ca/captcha.jpg`
		fetch(imageUrl, fetchGetConfig).then((res) => {
			return res.blob()
		}).then((res) => {
			var objcetURL = URL.createObjectURL(res)
			myImage.src = objcetURL
			// console.log(myImage.src);
			// this.getDigits()
			// console.log(myRequest)
			fetch(`https://captcha.kfsyscc.org/ca/digits`, fetchGetConfig).then((res) => {
				return res.json()
			}).then((data) => {
				// console.log('得到答案:', data.digit);
				LoginStore.veridation_code = data.digit;
			})
		})
	}
}

_.assign(LoginStore,
	{
		sendSmsCode: action(function (val) {

			if (this.input_veridation_code !== this.veridation_code) {
				swal("資料錯誤", "驗證碼輸入錯誤", "warning")
				return;
			}
			let obj = {
				id: LoginStore.id,
				password: md5(LoginStore.password),
			};

			let LoginAPI = "/SendSMSCode";
			fetch(LoginAPI, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(obj)
			})
				.then(checkStatus)
				.then(function (res) {
					return res.json();
				})
				.then(function (data) {
					// console.log('傳回:', data);
					if (data.code <= 299) {
						swal("驗證簡訊發送成功", data.res.msg, data.res.type)
							.then((value) => {
								LoginStore.showSmsView();
							});
					} else if (data.code >= 300) {
						swal("資料錯誤", data.res, "warning")
						getCaptcha();
					} else {
						swal("系統錯誤", "請聯絡病服人員", "error")
						getCaptcha();
					}
				})
		}),

		setShowDialog: action(function (val) {
			LoginStore.open = true
			LoginStore.dialogText = val
		}),

		showSmsView: action(function () {
			LoginStore.SmsView = true
		}),

		checkSmsCode: action(function (val) {
			let obj = {
				id: LoginStore.id,
				password: md5(LoginStore.password),
				code: Number(LoginStore.smscode),
			};

			let LoginAPI = "/TwoStepTokenSecurest";
			fetch(LoginAPI, {
				credentials: 'same-origin',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(obj)
			})
				.then(checkStatus)
				.then(function (res) {
					return res.json();
				})
				.then(function (data) {
					// console.log('傳回:', data);
					if (data.code <= 299) {
						// sessionStorage.setItem('token', data.token)
						const parsed = queryString.parse(location.search)
						if (parsed.next === undefined) {

							urlParam(window.location.href).app === 'true' ? location.href = '/secure_secret/health/?app=true' : location.href = '/secure_secret/health'

						} else {
							location.href = `${parsed.next}`
						}
					} else if (data.code >= 300) {
						swal("資料錯誤", data.res, "warning")
						getCaptcha();
					} else {
						swal("系統錯誤", "請聯絡病服人員", "error")
						getCaptcha();
					}
				})
		}),
	});

export default LoginStore



// WEBPACK FOOTER //
// ./src/stores/LoginStore.js